import '../styles/LeadsStepRail.css';
import React from 'react';

const STEPS = [
  { num: '01', name: 'Entry', href: '/' },
  { num: '02', name: 'Identity', href: '/login' },
  { num: '03', name: 'Extraction', href: '/extraction' },
  { num: '04', name: 'Leads', href: '/leads' },
];

const ACTIVE_STEP = '04';

function LeadsStepRail() {
  return (
    <section className="lsr-root" aria-labelledby="lsr-title">
      <div className="lsr-rail" data-content-rail="rail">
        <div className="lsr-head">
          <h2 className="lsr-head-label" id="lsr-title">Steps</h2>
          <p className="lsr-head-count" aria-hidden="true">{ACTIVE_STEP} / 04</p>
        </div>

        <nav className="lsr-strip" aria-label="Product steps">
          <ol className="lsr-list">
            {STEPS.map((step) => {
              const isActive = step.num === ACTIVE_STEP;
              return (
                <li className="lsr-item" data-step={step.num} key={step.num}>
                  <a
                    className="lsr-link"
                    href={step.href}
                    aria-current={isActive ? 'step' : undefined}
                  >
                    <span className="lsr-marker" aria-hidden="true" />
                    <span className="lsr-num">{step.num}</span>
                    <span className="lsr-name">{step.name}</span>
                  </a>
                </li>
              );
            })}
          </ol>
        </nav>

        <div className="lsr-foot">
          <p className="lsr-foot-label">Current step</p>
          <p className="lsr-foot-note">Leads · signed in</p>
        </div>
      </div>
    </section>
  );
}

export default LeadsStepRail;